/*
 *
 * @desc: 公共配置
 * @author: haifn
 * @time: 2019-06-25 10:26
 *
 */

export const CACHE_VERSION = 26;

// localStorage缓存上限，清除无效数据
(function clearCache() {
  const keys = [
    'cart_items',
    'diy_oner_list',
    'tradeup',
    'go_engraving',
    'cart_items_type',
    'pro_dis',
    'c_bind_services',
    'Go2LiveClosed',
    'region_modal',
    'personalized_data',
    'insta_go2_custom',
    'Insta',
  ];
  for (let i = 1; i < CACHE_VERSION; i++) {
    keys.forEach((o) => {
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem(`${i}_${o}`);
      }
    });
  }
})();

// 欧盟国家
export const EU_COUNTRY = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  // 'GB',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
];

// 欧洲国家 EUR + 挪威 - 英国 - 以色列
export const EUROPE_COUNTRY = [
  'AD',
  'AT',
  'BE',
  'BG',
  'CH',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'NO',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LI',
  'LT',
  'LU',
  'LV',
  'MC',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'RU',
  'SE',
  'SI',
  'SK',
];

/** 欧盟+挪威+英国 */
export const EU_COUNTRY_WITH_GB = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GR',
  'NO',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
];

/**
 *  欧盟英文国家 + 美国
 *  https://arashivision.feishu.cn/sheets/OSoJsQihBh7tCetT28AcXU75nJe?sheet=t9OLG2
 */
export const US_AND_EU_COUNTRY_CODE = [
  'US',
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'GR',
  'HU',
  'IE',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'SE',
];

/** 东南亚国家 */
export const SEA_COUNTRY = ['MY', 'PH', 'SG', 'TH', 'VN', 'BN', 'ID'];
/** 港澳台 */
export const TC_COUNTRY = ['HK', 'MO', 'TW'];
/** 东南亚 + 港澳台 */
export const AS_COUNTRY_MAIN = SEA_COUNTRY.concat(TC_COUNTRY);

/** 亚太地区国家 */
const AS_COUNTRY = ['AU', 'BN', 'CN', 'HK', 'HK', 'ID', 'JP', 'KR', 'MO', 'MY', 'NZ', 'PH', 'SG', 'TH', 'TW', 'VN'];

export const isASCountry = (CountryCode) => AS_COUNTRY.includes(CountryCode);
